import React, { createContext, useContext, useState, useCallback } from "react";

const DICT = {
  de: {
    "nav.dashboard": "Dashboard",
    "nav.vehicles": "Fahrzeuge",
    "nav.capture": "Fahrzeug hinzufügen",
    "nav.fotobooth": "Fotobooth",
    "nav.publishing": "Veröffentlichen",
    "nav.content": "Content Studio",
    "nav.integrations": "Integrationen",
    "nav.settings": "Einstellungen",
    "common.save": "Speichern",
    "common.cancel": "Abbrechen",
    "common.back": "Zurück",
    "common.next": "Weiter",
    "common.search": "Suchen...",
    "common.loading": "Wird geladen...",
    "common.logout": "Abmelden",
    "common.confirm": "Bestätigen",
    "common.open": "Öffnen",
    "common.all": "Alle",
    "login.title": "Anmelden",
    "login.subtitle": "Das KI-Publishing-System für Autohändler",
    "login.email": "E-Mail",
    "login.password": "Passwort",
    "login.submit": "Anmelden",
    "login.demo": "Demo-Zugänge",
    "vehicles.title": "Fahrzeuge",
    "vehicles.new": "Fahrzeug hinzufügen",
    "tab.overview": "Übersicht",
    "tab.data": "Fahrzeugdaten",
    "tab.photos": "Fotos",
    "tab.condition": "Zustand & Schäden",
    "tab.description": "Inserat",
    "tab.publish": "Veröffentlichen",
    "tab.history": "Historie",
    "assistant.title": "KI-Assistent",
  },
  en: {
    "nav.dashboard": "Dashboard",
    "nav.vehicles": "Vehicles",
    "nav.capture": "Add vehicle",
    "nav.fotobooth": "Fotobooth",
    "nav.publishing": "Publish",
    "nav.content": "Content Studio",
    "nav.integrations": "Integrations",
    "nav.settings": "Settings",
    "common.save": "Save",
    "common.cancel": "Cancel",
    "common.back": "Back",
    "common.next": "Next",
    "common.search": "Search...",
    "common.loading": "Loading...",
    "common.logout": "Log out",
    "common.confirm": "Confirm",
    "common.open": "Open",
    "common.all": "All",
    "login.title": "Sign in",
    "login.subtitle": "The AI publishing system for car dealers",
    "login.email": "Email",
    "login.password": "Password",
    "login.submit": "Sign in",
    "login.demo": "Demo accounts",
    "vehicles.title": "Vehicles",
    "vehicles.new": "Add vehicle",
    "tab.overview": "Overview",
    "tab.data": "Vehicle data",
    "tab.photos": "Photos",
    "tab.condition": "Condition & damages",
    "tab.description": "Listing",
    "tab.publish": "Publish",
    "tab.history": "History",
    "assistant.title": "AI Assistant",
  },
};

const LangContext = createContext(null);

export const LangProvider = ({ children }) => {
  const [lang, setLangState] = useState(localStorage.getItem("caros_lang") || "de");
  const setLang = useCallback((l) => {
    localStorage.setItem("caros_lang", l);
    setLangState(l);
  }, []);
  const t = useCallback((key) => DICT[lang]?.[key] || DICT.de[key] || key, [lang]);
  return <LangContext.Provider value={{ lang, setLang, t }}>{children}</LangContext.Provider>;
};

export const useLang = () => useContext(LangContext);
